export class CBadge extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const variant = this.getAttribute("variant") || "primary";
    const size = this.getAttribute("size") || "M";

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: inline-flex;
          align-items: center;
          border-radius: 12px;
          font-weight: 500;
          gap: 6px;
          padding: 0 10px;
          user-select: none;
        }

        .badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: ${variant === 'outline' ? 'var(--tempora-primary)' : variant == 'other' ? 'var(--black)' : 'var(--white)'};
          background-color: ${variant === 'other' ? 'var(--attention)' : variant === 'blur' ? 'var(--black-48)' : variant === 'outline' ? 'transparent' : 'var(--tempora-primary)'};
          border: 1px ${variant === 'outline' ? 'var(--tempora-primary)' : 'transparent'} solid !important;
          font-size: ${size === 'S' ? '13px' : '16px'};
          padding-inline: ${size == "M" ? '16px' : '8px'};
          padding-block: ${size == 'M' ? '7px' : '4px'};
          border-radius: 100px;
          backdrop-filter: ${variant == 'blur' ? 'blur(3px)' : 'none'}
        }

        ::slotted(img[slot="icon"]) {
          width: 16px;
          height: 16px;
        }
      </style>

      <span class="badge">
        <slot name="icon"></slot>
        <slot></slot>
      </span>
    `;
  }
}

customElements.define("c-badge", CBadge);